import type { ComponentProps } from "react"
import { forwardRef } from "react"

type Props = ComponentProps<"svg">

export const TreeIcon = forwardRef<SVGSVGElement, Props>((props, ref) => (
	<svg
		width="1em"
		height="1em"
		viewBox="0 0 16 16"
		xmlns="http://www.w3.org/2000/svg"
		ref={ref}
		{...props}
	>
		<path
			fill="currentColor"
			d="M12.5002 8C12.0441 8.60722 11.3179 9 10.5 9C9.65447 9 8.90699 8.58025 8.45455 7.93776C7.91162 8.58025 7.01463 9 6 9C5.01749 9 4.1453 8.60641 3.59808 7.99811C3.56554 7.99937 3.53285 8 3.5 8C2.11929 8 1 6.88071 1 5.5C1 4.11929 2.11929 3 3.5 3C3.67145 3 3.83887 3.01726 4.00062 3.05013C4.00021 3.03347 4 3.01676 4 3C4 1.89543 4.89543 1 6 1C6.58262 1 7.10705 1.24912 7.47259 1.64666C8.04463 1.23947 8.74435 1 9.5 1C10.8983 1 12.1051 1.82002 12.6657 3.00541C13.9692 3.09072 15 4.17498 15 5.5C15 6.88065 13.8808 7.9999 12.5002 8Z"
		/>
		<path
			fill="currentColor"
			d="M6.5 10C6.5 10 6.57058 10.3486 6.51278 10.6682C6.24708 12.1376 5.65716 13.8428 5 14.5C4.91086 14.5891 4.93776 14.7093 4.97125 14.8589C4.98121 14.9033 4.99175 14.9504 4.99999 15H11C11.0083 14.9504 11.0188 14.9033 11.0287 14.8588C11.0622 14.7093 11.0891 14.5891 11 14.5C10.3454 13.8454 9.77968 12.1621 9.52568 10.6986C9.45987 10.3194 9.5 10 9.5 10C9.15076 9.8695 8.78026 9.73501 8.5 9.5C8.00188 9.86223 7.15243 9.89997 6.5 10Z"
		/>
	</svg>
))
